/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { useReactToPrint } from 'react-to-print';
import TM23 from './TM23';
import { ITaxInvoice } from '@/interfaces/report';
import dayjs from 'dayjs';
import { ISetting } from '@/interfaces/setting';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  data: ITaxInvoice[];
  tms: string[];
  date: Date;
  setting: ISetting;
}

const PrintModal = ({
  open,
  handleCancel,
  data,
  tms,
  date,
  setting,
}: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `tax-invoice-report-${dayjs().format('YYYY-MM-DD')}`,
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          {tms.includes('TM26') && (
            <TM23 data={data} date={date} setting={setting} />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
